(() => {
  const cache = new WeakMap();
  const fields = {description:'paragraphs',inBrief:'paragraphs',highlights:'items'};
  const object = value => value !== null && typeof value === 'object' && !Array.isArray(value);
  function valid(payload) {
    if (!object(payload) || payload.schema_version !== 1 || payload.status !== 'verified') return false;
    if (Object.keys(payload).some(key=>!['schema_version','status',...Object.keys(fields)].includes(key))) return false;
    return Object.entries(fields).every(([key,list]) => {
      if (!Object.prototype.hasOwnProperty.call(payload,key)) return true;
      const entry = payload[key];
      return object(entry) && ['append','replace'].includes(entry.mode) &&
        Object.keys(entry).every(k=>k==='mode'||k===list) && Array.isArray(entry[list]) && entry[list].every(t=>typeof t==='string');
    });
  }
  if (customElements.get('ae-variant-content')) return;
  customElements.define('ae-variant-content',class extends HTMLElement {
    connectedCallback() {
      this.initialize = () => {
        if (this.onVariantChange || this.closest('quick-add-modal,quick-view-modal')) return;
        const source = document.getElementById(`VariantContent-${this.dataset.vcProduct}`);
        if (!source) return;
        let context;
        try {
          if (!cache.has(source)) cache.set(source,JSON.parse(source.textContent));
          context = cache.get(source);
        } catch { return; }
        const mains = [...document.querySelectorAll('section[id^="MainProduct-"]')].filter(main =>
          main.dataset.productHandle === context.handle && !main.closest('quick-add-modal,quick-view-modal'));
        if (mains.length !== 1 || String(context.productId)!==this.dataset.vcProduct || !Array.isArray(context.variantIds) || !fields[this.dataset.vcField]) return;
        this.main=mains[0];this.context=context;this.ids=new Set(context.variantIds.map(String));
        this.field=this.dataset.vcField;
        this.list=this.field==='highlights'?this.parentElement.querySelector('[data-vc-list]'):null;
        this.common=this.list?[...this.list.querySelectorAll('[data-vc-common]')]:[this.querySelector('[data-vc-common]')];
        this.specific=this.list||this.querySelector('[data-vc-specific]');
        if (!this.specific) return;
        this.onVariantChange = event => {
          if (String(event.detail?.sectionId)!==this.main.dataset.section) return;
          this.update(String(event.detail?.variant?.id));
        };
        document.addEventListener('variant:change',this.onVariantChange);
        const input=this.main.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        this.update(String(input?.value||context.initialVariantId));
      };
      if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',this.initialize,{once:true});
      else this.initialize();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded',this.initialize);
      document.removeEventListener('variant:change',this.onVariantChange);
      this.onVariantChange=null;
    }
    update(id) {
      if (!this.ids.has(id) || this.currentId===id) return;
      this.currentId=id;
      const payload=this.context.payloads[id];
      const entry=valid(payload)?payload[this.field]:null;
      const texts=entry?entry[fields[this.field]].filter(text=>text.trim()!==''):[];
      const replace=texts.length>0 && entry.mode==='replace';
      this.common.forEach(node=>{if(node)node.hidden=replace;});
      if (this.list) this.list.querySelectorAll('[data-vc-specific]').forEach(node=>node.remove());
      else this.specific.replaceChildren();
      for (const text of texts) {
        const node=document.createElement(this.list?'li':'p');
        node.className='ae-vc-text'+(this.field==='inBrief'?' pdp-optimus-brief__text':'');
        node.textContent=text;
        if (this.list) node.dataset.vcSpecific='';
        this.specific.append(node);
      }
      if (this.list) {
        const owner=this.closest('pdp-accessory-characteristics');
        if (owner?.variants?.[id] && typeof owner.updateExclusions==='function') owner.updateExclusions(owner.variants[id]);
        else if (owner) owner.hidden=![...this.list.children].some(li=>li.tagName==='LI'&&!li.hidden);
      } else {
        const empty=!(this.dataset.vcCommonPresent==='true'&&!replace)&&texts.length===0;
        this.hidden=empty;this.dataset.vcEmpty=String(empty);
        const section=this.closest('[data-pdp-kind="description"]');
        if (section) {
          section.hidden=empty;
          const details=section.closest('.ae-pdp-details');
          const link=[...(details?.querySelectorAll('.ae-pdp-anchors a')||[])].find(a=>a.getAttribute('href')==='#'+section.id);
          if (link)link.hidden=empty;
          const shell=details?.querySelector('[data-pdp-navigation]');
          if (shell)shell.hidden=[...shell.querySelectorAll('.ae-pdp-anchors a')].every(a=>a.hidden);
        }
      }
    }
  });
})();
